__turbopack_context__.v({
  "btn": "styles-module-scss-module__yJGX2a__btn",
  "root": "styles-module-scss-module__yJGX2a__root",
  "title": "styles-module-scss-module__yJGX2a__title",
});
